module.exports = __webpack_public_path__ + "static/media/49-active.09eadd5b.png";